import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { FeildMappingEntity } from './entities/feild-mapping-entity';
import { HeadersEntity } from './entities/headers-entity';
import { LineItemsEntity } from './entities/line-items-entity';
import { FeildMappingRepository } from './repository/feild-mapping-repo';
import { HeadersRepository } from './repository/headers-repo';
import { LineItemsRepository } from './repository/line-items-repo';
import { VardhamanController } from './vardhaman.controller';
import { VardhamanService } from './vardhaman.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([HeadersEntity, LineItemsEntity, FeildMappingEntity])],
  controllers: [VardhamanController],
  providers: [VardhamanService, HeadersRepository, LineItemsRepository, ApplicationExceptionHandler, FeildMappingRepository]
})
export class VardhamanModule { }
